/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentScenarioControllerGetQueryResponse, IncidentScenarioControllerGetPathParams } from "../../models/incidentAgentController/IncidentScenarioControllerGet";

function getIncidentScenarioControllerGetUrl(id: IncidentScenarioControllerGetPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/incident-agent/scenarios/${id}` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/scenarios/:id}
 */
export async function incidentScenarioControllerGet(id: IncidentScenarioControllerGetPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentScenarioControllerGetQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentScenarioControllerGetUrl(id).url.toString(), ... requestConfig })  
  return res.data
}